import React from 'react';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import ThemeSwitcher from './components/ThemeSwitcher';
import './index.css';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

const queryClient = new QueryClient();
const container = document.getElementById('root');
const root = createRoot(container!);

if (PUBLISHABLE_KEY) {
  // Full app — Clerk auth enabled
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
        <QueryClientProvider client={queryClient}>
          <App />
          <ThemeSwitcher />
        </QueryClientProvider>
      </ClerkProvider>
    </React.StrictMode>
  );
} else {
  // Preview mode — no Clerk key configured yet.
  // Landing page and public routes work; auth routes are UI-only.
  // To enable auth: add VITE_CLERK_PUBLISHABLE_KEY to .env (see .env.example)
  console.warn(
    '[Tinkerlog] VITE_CLERK_PUBLISHABLE_KEY is not set.\n' +
    'Running in preview mode — landing page only, auth is disabled.\n' +
    'Add your Clerk publishable key to .env to enable auth.'
  );
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App clerkEnabled={false} />
        <ThemeSwitcher />
      </QueryClientProvider>
    </React.StrictMode>
  );
}
